import { render, staticRenderFns } from "./AllergensEmptyState.vue?vue&type=template&id=26b73697&scoped=true"
import script from "./AllergensEmptyState.vue?vue&type=script&lang=ts"
export * from "./AllergensEmptyState.vue?vue&type=script&lang=ts"
import style0 from "../wellness/wellness-base.css?vue&type=style&index=0&id=26b73697&prod&scoped=true&lang=css&external"
import style1 from "./AllergensEmptyState.vue?vue&type=style&index=1&id=26b73697&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b73697",
  null
  
)

export default component.exports